import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ApiService} from '../../../services/api.service';
import {NotificationsService} from "angular2-notifications";
import {PieChartComponent} from '../zoomView/pie-chart/pie-chart.component';
import {ModalService} from "../../../services/modalService/modal.service";
import { TranslateService } from '@ngx-translate/core';
import { BackendTranslateService } from '../../../helper/backend-translate.service';
@Component({
  selector: 'app-session-length',
  templateUrl: './session-length.component.html',
  styleUrls: ['./session-length.component.css', '../myreports.component.css']
})
export class SessionLengthComponent implements OnInit {

  ruid: string;
  isLicense: string;
  public pie_ChartData = [];
  public sessions_durations: any = {};
  public pie_ChartOptions = {
    height: 500,
    titlePosition: 'out',
      chartArea: {height: '100%', width: '60%', left: 150},
    colors: ['#3f51b5', '#f44336', '#ffc107', '#4caf50', '9c27b0'],
    showAnnotations: true
  };

  chartError = false;
  constructor(private apiService: ApiService,
              private route: ActivatedRoute,
              private notifications: NotificationsService,
              private modalService: ModalService,
              private translate: TranslateService,
              private reportTranslate: BackendTranslateService) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params.ruid) {
        this.ruid = params.ruid;
        // const that = this;
        this.apiService.getSummary(this.ruid)
          .subscribe((res) => {
            this.isLicense = res.isLicense;
            if (!res.isLicense) {
              this.apiService.getChartData(this.ruid, 'SESSIONS_BY_DURATION')
                .subscribe((chartRes) => {
                  this.sessions_durations = chartRes;
                  this.pie_ChartData = this.sessions_durations.data;
                  //translating report data that is coming from server
                  this.pie_ChartData.forEach((element, index) => {
                    if(index === 0) {
                      this.pie_ChartData[index] = this.reportTranslate.translateCollection(element);
                    }
                    this.pie_ChartData[index][0] = this.reportTranslate.translateMessage(element[0]);

                  });
                }, (chartErr) => {
                    this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(chartErr, this.translate.instant('reports.sessionFail')));
                });
            }
          }, (error) => {
              this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(error, this.translate.instant('reports.invalidRuid')));
          });
      }
    });
  }

  zoomView() {
      if (this.pie_ChartData.length === 0) {
          return;
      }
    this.modalService.open(PieChartComponent, {
      title: this.translate.instant('reports.sessionLenght.title'),
      data: {
        chartData: this.sessions_durations,
        isLicense: this.isLicense,
        options: this.pie_ChartOptions
      }
    }).subscribe(model => {
    });
  }

}







// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/session-length/session-length.component.ts